import { render, staticRenderFns } from "./CombinationEditor.vue?vue&type=template&id=449b32e9"
import script from "./CombinationEditor.vue?vue&type=script&lang=js"
export * from "./CombinationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports